module.exports = __webpack_public_path__ + "media/hallBgm.725ad71c.mp3";